<template>
  <vs-prompt buttons-hidden title="Create Order Shipment Label" :active="createOrderShipmentLabelDialog.show" @close="close" class="create-order-shipment-label-dialog">
    <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>
    <vs-alert title="" :active="!!errors.serverError" color="danger">{{ errors.serverError }}</vs-alert>

    <div class="vx-row p-4">
      <vs-input
        required
        :danger="!!errors.trackingNumber"
        :danger-text="errors.trackingNumber ? errors.trackingNumber : null"
        val-icon-danger="error_outline"
        class="w-full mb-3"
        type="text"
        label="Tracking Number"
        v-model="form.trackingNumber"
      />
      <vs-input
        required
        :danger="!!errors.shippingName"
        :danger-text="errors.shippingName ? errors.shippingName : null"
        val-icon-danger="error_outline"
        class="w-full mb-3"
        type="text"
        label="Shipping Company"
        v-model="form.shippingName"
      />
      <vs-input
        required
        :danger="!!errors.shippingMethod"
        :danger-text="errors.shippingMethod ? errors.shippingMethod : null"
        val-icon-danger="error_outline"
        class="w-full mb-3"
        type="text"
        label="Shipping Method"
        v-model="form.shippingMethod"
      />
      <vs-input
        required
        :danger="!!errors.shipDate"
        :danger-text="errors.shipDate ? errors.shipDate : null"
        val-icon-danger="error_outline"
        class="w-full mb-3"
        type="date"
        label="Shipping Date"
        v-model="form.shipDate"
      />
    </div>

    <div class="vx-row">
      <div class="vx-col w-full my-2">
        <vs-button
          class="float-right"
          color="primary"
          type="border"
          :disabled="loading"
          @click="createShipmentLabel"
        >
          Create
        </vs-button>
        <vs-button
          class="float-right mr-2"
          color="primary"
          @click="close"
          :disabled="loading"
        >
          Cancel
        </vs-button>
      </div>
    </div>
  </vs-prompt>
</template>

<script>
  import api from "@/http/api";

  export default {
    props: [
      'refresh',
      'createOrderShipmentLabelDialog'
    ],
    data() {
      return {
        loading: false,
        form: {
          trackingNumber: null,
          shippingMethod: null,
          shippingName: null,
          shipDate: null,
        },
        errors: {}
      }
    },
    mounted() {

    },
    methods: {
      async createShipmentLabel() {
        this.errors = this.validate();
        if (Object.keys(this.errors).length) return;

        this.loading = true;
        const success = await api.createOrderShipmentLabel(this.createOrderShipmentLabelDialog.orderId, this.createOrderShipmentLabelDialog.shipmentLocationId, this.form);
        this.loading = false;

        if (!success) this.errors.serverError = 'Could not create shipment label record';

        await this.refresh();
        this.close();
      },
      validate() {
        let errors = {};

        if (!this.form.trackingNumber) errors.trackingNumber = 'Tracking number is required';
        if (!this.form.shippingName) errors.shippingName = 'Shipping company is required';
        if (!this.form.shippingMethod) errors.shippingMethod = 'Shipping method is required';
        if (!this.form.shipDate) errors.shipDate = 'Shipping date is required';

        return errors;
      },
      close() {
        this.errors = {};
        this.$emit('update:createOrderShipmentLabelDialog', {
          show: false,
          orderId: null,
          shipmentLocationId: null
        });
      },
    },
  }
</script>

<style lang="scss">
  .create-order-shipment-label-dialog{
    .vs-dialog {
      max-width: 750px;
    }
  }
</style>
